__webpack_require__.p = "/b/a/ecom-website/b5004f12fd885ff4d84346dfe13dc04974de3d41/_next/";